import { useFetchAllProjects } from '@/modules/projects'
import { useGettingStartedSteps } from '../hooks'
import { nextOpenStep, stepCountWord } from '../steps'
import { useGettingStartedStore } from '../store'
import { useTourTarget } from '../tourProgress'
import { GettingStartedStep } from './GettingStartedStep'
import { TourProgress } from './TourProgress'

export function GettingStartedPage() {
  useFetchAllProjects()
  const steps = useGettingStartedSteps()
  const target = useTourTarget()
  const doneSteps = useGettingStartedStore((state) => state.doneSteps)
  const nextStep = nextOpenStep(steps, doneSteps)
  const doneCount = steps.filter((step) => doneSteps.includes(step.key)).length
  // Project screens are empty until statements are processed, so their
  // buttons wait for a processed project.
  const readyProject = target.kind === 'ready' ? target.project : null
  // Adding statements only needs the project to exist.
  const anyProject = target.kind === 'no-project' ? null : target.project

  return (
    <div className="mx-auto max-w-5xl space-y-10 pb-8">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-pretty text-3xl font-bold tracking-tight text-blue-7">
            Getting started
          </h1>
          <p className="mt-2 text-pretty text-base text-blue-6">
            {stepCountWord(steps.length)} short steps from your first statement
            to a finished report. About four minutes.
          </p>
        </div>
        <div className="flex items-center gap-3 text-sm text-blue-6">
          <TourProgress
            className="flex"
            total={steps.length}
            done={doneCount}
          />
          {doneCount} of {steps.length} done
        </div>
      </header>

      <ol className="space-y-6">
        {steps.map((step, index) => (
          <GettingStartedStep
            key={step.key}
            step={step}
            number={index + 1}
            project={
              step.action?.kind === 'add-statements' ? anyProject : readyProject
            }
            done={doneSteps.includes(step.key)}
            isNext={step === nextStep}
          />
        ))}
      </ol>
    </div>
  )
}
